import logo from './logo.svg';
import './App.css';
import HappyCare from './Registration/HappyCare';
import { BrowserRouter, Routes, Route } from "react-router-dom";
function App() {
  return (
    <BrowserRouter>
            <Routes>

                <Route path="/" element={<HappyCare />} />

                <Route
                    path="/registration"
                    element={<HappyCare />} />
                

                <Route
                    path="/success"
                    element={<HappyCare />}
                />

            </Routes>
        </BrowserRouter>
    
    
  );
}

export default App;
